import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {
  transform(value, args? : string[]): any {
      const result = [];
      const keys = Object.keys(value);

      for (const key of keys) {
          result.push({ key: key, value: value[key] });
      }

      return result;
  }
}
